import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7;
import { fontSize, fontWeight, lineHeight } from "../../../constants/typography";
import { NeutralColors } from "../../../constants/colors";
import mediaQueries from "../../../util/mediaqueries";
import styled, { css } from 'styled-components';
import { SIZES } from "./";
export var SuperHero = styled.h1.withConfig({
  componentId: "sc-1qvb16p-0"
})(["color:", ";font-style:normal;font-weight:", ";letter-spacing:-0.01em;font-size:", ";line-height:", ";", ";", ";"], function (_ref) {
  var inverted = _ref.inverted;
  return inverted ? NeutralColors.White : NeutralColors.Ink;
}, fontWeight.regular, fontSize.x3Large, lineHeight.xSmall, mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), 0)), fontSize.x4Large), mediaQueries.lg(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), 0)), fontSize.x5Large));
export var Hero = styled.h2.withConfig({
  componentId: "sc-1qvb16p-1"
})(["color:", ";font-style:normal;font-weight:normal;font-size:", ";line-height:", ";", ";", ";"], function (_ref2) {
  var inverted = _ref2.inverted;
  return inverted ? NeutralColors.White : NeutralColors.Ink;
}, fontSize.x2Large, lineHeight.xSmall, mediaQueries.sm(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-weight: ", ";\n    font-size: ", ";\n    letter-spacing: -0.01em;\n  "])), 0, 0)), fontWeight.regular, fontSize.x3Large), mediaQueries.lg(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), 0)), fontSize.x4Large));
var baseHeadlineSize0CSS = css(["font-size:", ";line-height:", ";"], fontSize.large, lineHeight.small);
var baseHeadlineSize1CSS = css(["font-size:", ";line-height:", ";", ";"], fontSize.xLarge, lineHeight.small, mediaQueries.lg(_t5 || (_t5 = _(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), 0, 0)), fontSize.x2Large, lineHeight.xSmall));
var baseHeadlineSize2CSS = css(["font-size:", ";line-height:", ";", ";", ";"], fontSize.xLarge, lineHeight.small, mediaQueries.sm(_t6 || (_t6 = _(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), 0, 0)), fontSize.x2Large, lineHeight.xSmall), mediaQueries.lg(_t7 || (_t7 = _(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-weight: ", ";\n    font-size: ", ";\n    letter-spacing: -0.01em;\n  "])), 0, 0)), fontWeight.regular, fontSize.x3Large));
export var BaseHeadline = styled.h2.withConfig({
  componentId: "sc-1qvb16p-2"
})(["color:", ";font-style:normal;font-weight:normal;", ";"], function (_ref3) {
  var inverted = _ref3.inverted;
  return inverted ? NeutralColors.White : NeutralColors.Ink;
}, function (_ref4) {
  var size = _ref4.size;
  switch (size) {
    case SIZES.SMALL:
      return baseHeadlineSize0CSS;
    case SIZES.LARGE:
      return baseHeadlineSize2CSS;
    default:
    case SIZES.MEDIUM:
      return baseHeadlineSize1CSS;
  }
});